import { Component, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.css']
})

export class FileUploaderComponent {
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  selectedFiles: File[] = [];
  isDragging = false;

  formatSize(size: number): string {
    return (size / (1024 * 1024)).toFixed(2) + 'MB'; // Convierte a MB con 2 decimales
  }

  triggerFileInput() {
    this.fileInput.nativeElement.click(); // Simula clic en el input oculto
  }

  onFilesSelected(event: any) {
    const files: FileList = event.target.files;
    this.addFiles(files);
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
    if (event.dataTransfer?.files) {
      this.addFiles(event.dataTransfer.files);
    }
  }

  addFiles(files: FileList) {
    this.selectedFiles = [...this.selectedFiles, ...Array.from(files)];
  }

  removeFile(index: number) {
    this.selectedFiles.splice(index, 1);
  }
  

  uploadFiles() {
    if (this.selectedFiles.length === 0) {
      alert('No hay archivos para subir.');
      return;
    }
    
    console.log('Subiendo archivos:', this.selectedFiles);
    alert('Archivos subidos exitosamente.');
  }
}
